import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Title from "../Title";
import { useTranslation } from "react-i18next";
import {
  Container,
  Close,
  ContainerLegend,
  Button,
  TitleButton,
  ContainerButton,
  ContainerProduct,
  Image,
  TitleProduct,
  ContainerTabs,
  Tab,
  Checkbox,
  ContainerCheckbox,
  TitleProducts,
  Input,
  Select,
  InputImage,
  TagFile,
  MediaName,
  ContainerTag,
} from "./styled";
import { AiOutlineFile, AiOutlineLink } from "react-icons/ai";
import { IoClose } from "react-icons/io5";
import { RiFilePaper2Line } from "react-icons/ri";
import Loading from "../../components/Loading";
import { translations } from "../../utils/language";

const ModalAdd = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [productId, setProductId] = useState(0);
  const [mediaId, setMediaId] = useState([]);
  const [tabSelected, setTabSelected] = useState(0);
  // const [tabSelected, setTabSelected] = useState(0);
  const [existingFile, setExistingFile] = useState(false);
  const [productIsChecked, setProductIsChecked] = useState([]);
  const [isArchive, setIsArchive] = useState(true);
  const [isUrl, setIsUrl] = useState(false);
  const [files, setFiles] = useState([]);
  const [url, setUrl] = useState("");
  const [urls, setUrls] = useState([]);
  const [width, setWidth] = useState("");
  const [padding, setPadding] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [loadingMedias, setLoadingMedias] = useState(false);
  const [mediasSelected, setMediasSelected] = useState([]);
  const [reRender, setReRender] = useState(false);
  const medias = useSelector((state) => state.reducerMedias);
  const language = useSelector((state) => state.reducerLanguage);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: width,
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      padding: padding,
      margin: "0px",
      borderRadius: "10px",

    },
    overlay: {
      backgroundColor: "rgba(10,23,55,0.5)",
      zIndex: "99999999"
    },
  };

  const productChecked = [];

  // useEffect(() => {
  //   if (medias?.data?.data) {
  //     setMediaId([{ id: medias?.data?.data[0]?.id }]);
  //   }
  // }, [medias]);

  useEffect(() => {
    setWidth(window.innerWidth > 700 ? "55%" : "90%");
    setPadding(window.innerWidth > 700 ? "10px" : "4px");
  }, [window]);

  function handleLinkMediaProducts() {
    props.products.map((variant) => {
      dispatch({
        type: "LINK_MEDIA_PRODUCTS",
        payload: {
          media_id: mediaId,
          variant_id: variant?.id?.toString(),
          product_id: variant.productId,
        },
      });
    });
    setSaveLoading(false);
    history.push("/midias");
  }

  useEffect(() => {
    dispatch({
      type: "SAGA_LIST_MEDIA",
      payload: {
        perPage: 100,
        page: 1,
      },
    });
  }, [dispatch]);

  function linkMediaProducts(mediaId) {
    props.products.map((variant) => {
      dispatch({
        type: "LINK_MEDIA_PRODUCTS",
        payload: {
          media_id: mediaId,
          variant_id: variant.variantId,
          product_id: variant.productId,
        },
      });
    });
    // history.push("/produtos");
  }

  async function handleImageUpload(imageFile) {
    try {
      // const compressedFile = await imageCompression(imageFile, options);
      setMediasSelected((oldArray) => [...oldArray, { name: imageFile.name }]);
      setFiles((oldArray) => [...oldArray, { file: imageFile }]);
    } catch (error) { }
  }

  function deleteTag(item, index) {
    mediaId.map((element, idx) => {
      if (element.name === item.name) {
        mediaId.splice(idx, 1);
        setMediaId(mediaId);
      }
    });
    urls.map((element, idx) => {
      if (element.name === item.name) {
        urls.splice(idx, 1);
        setUrls(urls);
      }
    });
    files.map((element, idx) => {
      if (element.file.name === item.name) {
        files.splice(idx, 1);
        setFiles(files);
      }
    });
    mediasSelected.splice(index, 1);
    setMediasSelected(mediasSelected);
    setReRender((prevState) => !prevState);
  }


  function uploadUrl() {
    if (mediasSelected.length === 0) {
      return toast.error("Suba um arquivo ou url");
    }
    setSaveLoading(true);
    if (urls.length > 0) {
      dispatch({
        type: "SAGA_UPLOAD_URL",
        payload: {
          url: urls,
          limit: 0,
          message: "",
          variants: (mediaId) => linkMediaProducts(mediaId),

          //navigation: () => (files.length === 0 ? history.push("/midias") : {}),
          navigation: () => console.log(""),
        },
      });
    }
    if (mediaId.length > 0) {
      props.products.map((variant) => {
        mediaId.map((item, index) => {
          dispatch({
            type: "LINK_MEDIA_PRODUCTS",
            payload: {
              media_id: item.id,
              variant_id: variant?.variantId?.toString(),
              product_id: variant.productId,
            },
          });
          //files.length === 0 && mediaId.length === index + 1 && history.push("/midias");
        });
      });
    }
    if (files.length > 0) {
      dispatch({
        type: "SAGA_UPLOAD_MEDIA",
        payload: {
          url: url,
          media: files,
          limit: 0,
          message: "",
          variants: (mediaId) => linkMediaProducts(mediaId),
          //navigation: () => history.push("/midias"),
          navigation: () => console.log(""),
        },
      });
    }
    // }
    // });

    // variantsSelected.map((variant) => {
    //   dispatch({
    //     type: "LINK_MEDIA_PRODUCTS",
    //     payload: {
    //       media_id: "mediaId",
    //       variant_id: variant.id,
    //       product_id: variant.productId,
    //     },
    //   });
    // });
  }

  const mediasUpload = useSelector((state) => state.reducerMediasUpload);
  useEffect(() => {
    
    if (mediasUpload.loading == false && Object.keys(mediasUpload?.data)?.length > 0) {
      setSaveLoading(false)
      props.setVisibleModalAdd(false)
      setMediasSelected([]);
      setFiles([]);
      dispatch({
        type: "SAGA_LIST_PRODUCTS",
        payload: { search: "", perPage: 10, page: 1, },
      });
    }
  }, [mediasUpload])


  return (
    <Modal
      isOpen={props.visible}
      style={customStyles}
      ariaHideApp={false}
    // onRequestClose={() => { formik.resetForm(); props.setVisibleModal(false) }}
    >
      <Container>
        <Title marginBottom="16px">{t(props.title)}</Title>
        <Close
          onClick={() => {
            props.setVisibleModalAdd();
            setMediasSelected([]);
            setFiles([]);
          }}
        >
          X
        </Close>

        <div>
          {step === 0 &&
            // <>
            //   <ContainerLegend></ContainerLegend>
            //   <ContainerTabs>
            //     <Tab
            //       onClick={() => setTabSelected(0)}
            //       isSelected={tabSelected === 0}
            //     >
            //       Todos os produtos
            //     </Tab>
            //     <Tab
            //       onClick={() => setTabSelected(1)}
            //       isSelected={tabSelected === 1}
            //     >
            //       Selecionados
            //     </Tab>
            //   </ContainerTabs>
            // </>
            (props.products ? (
              props.products.map((item) => {
                return (
                  <>
                    <ContainerProduct
                      onClick={() => {
                        setProductIsChecked((oldArray) => [
                          ...oldArray,
                          item.id,
                        ]);
                      }}
                    >
                      {/* <AiOutlineFile size={30} /> */}

                      <TitleProduct>
                        {/* <input
                        type="checkbox"
                        id="scales"
                        name="scales"
                        checked={productIsChecked.includes(item.id)}
                      />{" "} */}
                        <RiFilePaper2Line size={30} /> {item.name}
                      </TitleProduct>
                    </ContainerProduct>
                    <ContainerTag
                      style={{
                        display: mediasSelected.length > 0 ? "grid" : "none",
                      }}
                    >
                      {mediasSelected.map((item, index) => (
                        <TagFile>
                          <MediaName style={{ margin: 0 }}>
                            <AiOutlineFile size={15} /> {item.name}
                          </MediaName>
                          <IoClose
                            size={14}
                            color="red"
                            onClick={() => deleteTag(item, index)}
                            style={{ cursor: "pointer" }}
                          />
                        </TagFile>
                      ))}
                    </ContainerTag>
                    <ContainerCheckbox>
                      <Checkbox
                        type="checkbox"
                        id="scales"
                        name="scales"
                        checked={isArchive}
                        onClick={() => {
                          setIsUrl(false);
                          setExistingFile(false);
                          setIsArchive(true);
                        }}
                      />{" "}
                      <TitleProducts
                        size={14}
                        marginTB={10}
                        marginLR={8}
                        onClick={() => {
                          setIsUrl(false);
                          setExistingFile(false);
                          setIsArchive(true);
                        }}
                      >
                        {translations["Fazer upload"][language.data]}
                      </TitleProducts>
                      <Checkbox
                        type="checkbox"
                        id="scales"
                        name="scales"
                        checked={existingFile}
                        onClick={() => {
                          setIsUrl(false);
                          setExistingFile(true);
                          setIsArchive(false);
                        }}
                      />{" "}
                      <TitleProducts
                        size={14}
                        marginTB={10}
                        marginLR={8}
                        onClick={() => {
                          setIsUrl(false);
                          setExistingFile(true);
                          setIsArchive(false);
                        }}
                      >
                        {translations["Vincular mídia"][language.data]}
                      </TitleProducts>
                      <Checkbox
                        type="checkbox"
                        id="scales"
                        name="scales"
                        checked={isUrl}
                        onClick={() => {
                          setIsUrl(true);
                          setExistingFile(false);
                          setIsArchive(false);
                        }}
                      />{" "}
                      <TitleProducts
                        size={14}
                        marginTB={10}
                        marginLR={8}
                        onClick={() => {
                          setIsUrl(true);
                          setExistingFile(false);
                          setIsArchive(false);
                        }}
                      >
                        Conectar URL
                      </TitleProducts>
                    </ContainerCheckbox>
                    <ContainerCheckbox>
                      {isArchive && (
                        <InputImage
                          type="file"
                          name="file"
                          onChange={(e) => {
      
                            let file = e.target.files[0];
                            handleImageUpload(file);
                       
                          }}
                        />
                      )}{" "}
                      {isUrl && (
                        <>
                          <Input
                            width={"100%"}
                            height={"50px"}
                            onChange={(e) => {
                              setUrl(e.target.value);
                            }}
                            placeholder="Exemplo: http://www.suaurl.com.br"
                          />
                          <Button
                            onClick={() => {
                              if (url.length > 0) {
                                setMediasSelected((oldArray) => [
                                  ...oldArray,
                                  { name: url },
                                ]);
                                setUrls((oldArray) => [
                                  ...oldArray,
                                  { name: url },
                                ]);
                              } else {
                                toast.error("Digite um url");
                              }
                            }}
                            style={{
                              height: 50,
                              width: 50,
                              marginLeft: 10,
                            }}
                          >
                            <TitleButton>
                              <AiOutlineLink size={30} color="white" />
                            </TitleButton>
                          </Button>
                        </>
                      )}
                      {existingFile &&
                        (medias?.data?.data?.length > 0 ? (
                          <Select
                            name="medias"
                            id="medias"
                            onSelect={() => alert("aqui")}
                            onChange={(a) => {
                              const json = JSON.parse(a.target.value);
                              setMediaId((oldArray) => [
                                ...oldArray,
                                { id: json.id, name: json.name },
                              ]);
                              // (oldArray) => [...oldArray, { name: imageFile.name }]}
                              setMediasSelected((oldArray) => [
                                ...oldArray,
                                { name: json.name },
                              ]);
                            }}
                          >
                            <option>Selecione uma mídia</option>
                            {medias?.data?.data?.map((item) => (
                              <option
                                value={JSON.stringify({
                                  id: item.id,
                                  name: item.media_name
                                    ? item.media_name
                                    : item.media,
                                })}
                              >
                                {item.media_name ? item.media_name : item.media}
                              </option>
                            ))}
                          </Select>
                        ) : (
                          <Select
                            name="medias"
                            id="medias"
                            onChange={(a) => setMediaId(a.target.value)}
                          >
                            <option value={item.id}>
                              Você não tem nenhuma mídia
                            </option>
                          </Select>
                        ))}
                    </ContainerCheckbox>
                  </>
                );
              })
            ) : (
              <h1>NADA</h1>
            ))}
          {step === 1 && <h1>AQUI</h1>}
          <ContainerButton>
            <Button
              onClick={() => {
                uploadUrl();
              }}
              style={{ cursor: "pointer" }}
            >
              {saveLoading ? <Loading /> : <TitleButton>VINCULAR</TitleButton>}
            </Button>
          </ContainerButton>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalAdd;
